import { HolmanLogo } from "@App/Components/atoms/whitelabel/logos/HolmanLogo";
import { RepareoLogo } from "@App/Components/atoms/whitelabel/logos/RepareoLogo";
import type { Config } from "@App/configs/interfaces";

/**
 * Configuration for the Holman whitelabel.
 * Extends the default configuration with specific settings for Holman.
 */
export const config: Partial<Config> = {
  slug: "holman",
  navbar: {
    logos: {
      left: {
        component: <HolmanLogo />,
      },
      right: {
        component: <RepareoLogo />,
      },
    },
    backToPartnerButton: {
      url: "https://holman.com/de-en/",
    },
  },
  reviews: {
    show: true,
  },
};

export default config;
